import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalVariablesService {

    siteName = signal<string>(""); 
    orgName = signal<string>(""); 
    userName = signal<string>(""); 
    eventName = signal<string>(""); 
    currentEventName = signal<string>(""); 
    currentEventId = signal<number>(0); 
    isNavFixed = signal<boolean>(false);
    onChangePasswordScreen = signal<boolean>(false);
}
